import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiPhone, FiMapPin, FiTerminal, FiArrowRight } = FiIcons;

export default function FooterSection() {
  return (
    <footer className="bg-black pt-24 pb-8 px-6 border-t border-white/10 relative overflow-hidden">
      {/* Telemetry Grid Line styling for the clinical "Inside" look */}
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>
      
      <div className="max-w-6xl mx-auto relative z-10 flex flex-col md:flex-row justify-between gap-16 mb-20">
        
        {/* Brand & Status Column */}
        <div className="flex flex-col gap-6 md:w-1/3">
          <div className="flex items-center gap-3">
            <div className="w-6 h-6 flex items-center justify-center shrink-0">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/b729ed0728dd00b56ad4432b7bed08bb6e0f1b37b57acc2ecba8e8caa91ad92afaa368f7ee662627c72dbcd9a47643b4/images/aW1hZ2UvcG5n/cd6c64635923cfb3391950ed67895587.png" 
                alt="Sans Titre Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-white font-semibold text-lg uppercase tracking-widest">SANS TITRE</span>
          </div>
          <p className="text-white/50 text-sm leading-relaxed max-w-sm">
            An independent creative studio. We capture the anomaly and give it form through brand, film, and design.
          </p>
          
          {/* Terminal Cyan Status Indicator */}
          <div className="flex items-center gap-2 text-[#00ffff] text-xs uppercase tracking-widest mt-2 border border-[#00ffff]/20 bg-[#00ffff]/5 px-3 py-1.5 w-fit rounded">
            <span className="w-1.5 h-1.5 rounded-full bg-[#00ffff] animate-pulse"></span>
            [SYS.OP: STABLE]
          </div>
        </div>

        {/* Links & Contact Columns */}
        <div className="flex flex-col sm:flex-row gap-12 md:w-2/3 md:justify-end">
          
          {/* Contact Us */}
          <div className="flex flex-col gap-5">
            <h4 className="text-white/40 text-xs tracking-widest uppercase mb-1">Initiate Contact</h4>
            <a href="mailto:hello@wearesanstitre.com" className="text-white/80 hover:text-white text-sm flex items-center gap-3 transition-colors group">
              <div className="liquid-glass p-2 rounded-full group-hover:bg-white/10 transition-colors">
                <SafeIcon icon={FiMail} className="w-3 h-3 text-white" />
              </div>
              hello@wearesanstitre.com
            </a>
            <a href="tel:+13105268412" className="text-white/80 hover:text-white text-sm flex items-center gap-3 transition-colors group">
              <div className="liquid-glass p-2 rounded-full group-hover:bg-white/10 transition-colors">
                <SafeIcon icon={FiPhone} className="w-3 h-3 text-white" />
              </div>
              (310) 526-8412
            </a>
            <div className="text-white/80 text-sm flex items-start gap-3 mt-2">
              <div className="liquid-glass p-2 rounded-full mt-1 shrink-0">
                <SafeIcon icon={FiMapPin} className="w-3 h-3 text-white" />
              </div>
              <span className="flex flex-col gap-1">
                <span className="tracking-wide">The Outpost</span>
                <span className="text-white/50 text-xs uppercase tracking-widest">Sacramento, California, USA</span>
              </span>
            </div>
          </div>

          {/* Legal Protocols links */}
          <div className="flex flex-col gap-4">
            <h4 className="text-white/40 text-xs tracking-widest uppercase mb-2">Protocols & Legal</h4>
            <Link to="/legal#privacy" className="text-white/70 hover:text-white text-sm transition-colors flex items-center gap-2 group">
              <SafeIcon icon={FiArrowRight} className="w-3 h-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all text-[#00ffff]" />
              Privacy Policy
            </Link>
            <Link to="/legal#terms" className="text-white/70 hover:text-white text-sm transition-colors flex items-center gap-2 group">
              <SafeIcon icon={FiArrowRight} className="w-3 h-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all text-[#00ffff]" />
              Terms of Service
            </Link>
            <Link to="/legal#cookie" className="text-white/70 hover:text-white text-sm transition-colors flex items-center gap-2 group">
              <SafeIcon icon={FiArrowRight} className="w-3 h-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all text-[#00ffff]" />
              Cookie Policy
            </Link>
            <Link to="/legal#legal" className="text-white/70 hover:text-white text-sm transition-colors flex items-center gap-2 group">
              <SafeIcon icon={FiArrowRight} className="w-3 h-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all text-[#00ffff]" />
              Legal Information
            </Link>
          </div>

        </div>
      </div>

      {/* Bottom Legal Bar */}
      <div className="max-w-6xl mx-auto relative z-10 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-white/40 text-xs tracking-wide">
          © 2026 Sans Titre. All rights reserved.
        </p>
        <p className="text-white/20 text-xs tracking-widest uppercase flex items-center gap-2">
          <SafeIcon icon={FiTerminal} className="w-3 h-3" />
          SANS TITRE // CREATIVE STUDIO
        </p>
      </div>
    </footer>
  );
}